export default __webpack_public_path__ + "static/media/mbstu.a57c4e93.png";